<template>
  <div>
    <div class="row">
      <card
        header-tag="header"
        class="mr-auto ml-auto mt-2 mb-2 pointer"
        v-for="p in participants"
        :key="p.Id"
      >
        <div
          class="text-center"
          @click="onParticipantSelected(p.ScouterKey)"
        >
          <div>
            <img
              class="bigavatar border-gray"
              v-if="p.PictureUrl"
              :src="p.PictureUrl"
              :title="p.FullName"
            >
            <img
              class="bigavatar border-gray"
              v-else
              src="@/assets/img/image-not-available.png"
              :title="p.FullName"
            >
          </div>
          <div>
            <b>{{ p.FullName }}</b>
          </div>
          <div v-if="p.Preferred">
            ({{ p.Preferred }})
          </div>
          <div>{{ p.PrimaryScoutingPosition }}</div>
          <div>{{ p.District }}</div>
          <div>{{ p.Occupation }}</div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ParticipantBiosPatrol',
  props: {
    participants: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  methods: {
    onParticipantSelected: function (selectedScouterKey) {
      const path = '/staff/participant?s=' + selectedScouterKey + '&r=bio'
      this.$router.push(path)
    }
  }
}
</script>
<style scoped>
img {
  width: 100px;
  height: 125px;
}
.pointer {
  cursor: pointer;
}
.card .bigavatar {
  width: 140px;
  height: 140px;
  overflow: hidden;
  border-radius: 50%;
  margin-bottom: 15px;
}
</style>
